module.exports = __webpack_public_path__ + "static/media/monthly fee icon.34a6c317.svg";